import { NgModule } from '@angular/core';
import { EmailBuilderModule, PreviewRenderingService } from '../../email-builder';
import { EmailLibraryEditorComponent } from '../../email-library/src/email-library-editor.component';
import { CommonModule } from '@angular/common';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyStatisticModule } from '@vendasta/galaxy/statistic';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { DynamicComponentSelectorModule } from '../../email-builder/src/components/dynamic-component-selector';
import { AsyncUiModule } from '@vendasta/uikit';
import { MatMenuModule } from '@angular/material/menu';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EmailLibraryListComponent } from '../../email-library/src/email-library-list/list.component';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyInfiniteScrollTriggerModule } from '@vendasta/galaxy/infinite-scroll-trigger';
import { EmailCardsComponent } from './email-library-list/email-cards/email-cards.component';
import { CardComponent } from '../../email-library/src/email-library-list/card/card.component';
import { RouterModule } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';

const MODULE_IMPORTS = [
  CommonModule,
  EmailBuilderModule,
  GalaxyInputModule,
  GalaxyPopoverModule,
  GalaxyAlertModule,
  GalaxyPipesModule,
  GalaxyPageModule,
  GalaxyStatisticModule,
  FormsModule,
  GalaxyFormFieldModule,
  MatDividerModule,
  DynamicComponentSelectorModule,
  AsyncUiModule,
  MatMenuModule,
  GalaxyLoadingSpinnerModule,
  MatButtonModule,
  MatIconModule,
  TranslateModule,
  MatFormFieldModule,
  MatInputModule,
  ReactiveFormsModule,
  GalaxyEmptyStateModule,
  GalaxyInfiniteScrollTriggerModule,
  RouterModule,
  GalaxyInputModule,
  MatExpansionModule,
];

@NgModule({
  declarations: [EmailLibraryEditorComponent, EmailLibraryListComponent, EmailCardsComponent, CardComponent],
  imports: [MODULE_IMPORTS],
  exports: [EmailLibraryEditorComponent, EmailLibraryListComponent],
  providers: [PreviewRenderingService],
})
export class EmailLibraryModule {}
